import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import FlagIcon from '@atlaskit/icon/core/flag';
import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';

import { useReportAbuseUrl } from './useReportAbuseUrl.ts';

const i18n = defineMessages({
	reportAbuseLabel: {
		id: 'report-abuse.menu-item.label',
		defaultMessage: 'Report Abuse',
		description:
			'The label of the Report Abuse button inside the ellipsis dropdown, which opens an Atlassian support page in a new tab for reporting abusive content',
	},
});

export type ReportAbuseMenuItemProps = {
	/** The content ID (e.g. Confluence page/blog/whiteboard ID) */
	contentId?: string | null;
	/** The Confluence content type, e.g. "page", "blogpost", "whiteboard" */
	contentType?: string | null;
	/** Optional click handler for analytics instrumentation */
	onClick?: () => void;
};

/**
 * A DropdownItem that links to the Atlassian Support abuse-report form,
 * pre-filling context about the current content (ati, ari, fileUrl, reporteraaid).
 */
export const ReportAbuseMenuItem = ({
	contentId,
	contentType,
	onClick,
}: ReportAbuseMenuItemProps): React.JSX.Element => {
	const href = useReportAbuseUrl({ contentId, contentType });

	return (
		<DropdownItem
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			onClick={onClick}
			elemBefore={<FlagIcon label="" />}
		>
			<FormattedMessage {...i18n.reportAbuseLabel} />
		</DropdownItem>
	);
};
